module.exports = __webpack_public_path__ + "media/images/flags/16/Falkland-Islands-b697ed1be6d5faa63387aeee84fca51c.png";